<template>
    <div style="position: relative">
        <div class="col-xs-3" style="height: 100%; padding:0" v-show="!loading">
            <dashboard-item-menu
                ref="attackometerDashboardItemMenu"
                :titleColor="mainTitleColor"
                :titleBackgroundColor="mainTitleBackgroundColor"
                :title="mainTitle"
                :menuList="attackometerMenuList"
                @menuItemClicked="onVendorSelect"></dashboard-item-menu>
        </div>
        <div ref="chronometerContainer" class="col-xs-9" style="height: 100%; position: relative;"
             v-show="selectedVendorItem">
            <div class="main-chronometer">
                <chronometer v-if="selectedVendorItem"
                             ref="mainChronometer"
                             :textColor="chronometerProgressColor"
                             :circleColor="chronometerProgressColor"
                             :backgroundCircleColor="chronometerRemainingProgressColor"
                             :progress="selectedVendorItem.progress"
                             :startFromBottom="true"
                             :useNeedle="true"
                             :instantDraw="true"
                             :numbers="attackometerNumbers"></chronometer>
            </div>
            <div class="sub-chronometer">
                <chronometer v-if="selectedVendorItem && selectedVendorItem.oldest_file"
                             ref="subChronometer"
                             :textColor="chronometerProgressColor"
                             :circleColor="chronometerProgressColor"
                             :backgroundCircleColor="chronometerRemainingProgressColor"
                             :progress="100"
                             :text="oldestUndetectedFileText"></chronometer>
            </div>
            <div class="text-container" v-if="selectedVendorItem">
                <svg viewBox="0 0 545 455" preserveAspectRatio="xMidYMid meet" ref="text-svg"
                     style="width:100%; height:100%;">
                    <text class="text" x="33%" y="80%" text-anchor="middle">{{selectedVendorItem.vendor}}</text>
                    <text class="text" x="33%" y="86%" text-anchor="middle">is currently not detecting</text>
                    <text class="text" x="33%" y="92%" text-anchor="middle">{{selectedVendorItem.file_count}}</text>
                    <text class="text" x="33%" y="98%" text-anchor="middle">files</text>

                    <text class="small-text" x="82%" y="53%" text-anchor="middle">Longest undetected file:</text>
                    <text class="small-text" x="82%" y="57%" text-anchor="middle">{{oldestFileName}}</text>
                </svg>
            </div>
        </div>
        <div class="enlarge-button grow" @click="onEnlargeClick" v-show="!loading">
            <img src="../../../assets/enlarge-button.svg" class="enlarge-button-icon"/>
        </div>
        <loading-modal v-if="loading" :color="'blue'"></loading-modal>
    </div>
</template>

<script>

    import DashboardItemMenu from '@/components/menu/DashboardItemMenu.vue'
    import Chronometer from '@/components/chronometer/Chronometer.vue'
    import Common from '@/utils/Common.vue'
    import Constants from '@/utils/constants'
    import LoadingModal from "@/components/modals/LoadingModal";

    const MENU_MAIN_TITLE_COLOR = "black";
    const MENU_MAIN_TITLE_BACKGROUND_COLOR = "rgb(255,190,45)";
    const MENU_ITEM_BACKGROUND_COLOR = "rgb(199,145,32)";
    const MENU_ITEM_COLOR = "rgb(63,92,111)";
    const MENU_TITLE_COLOR = "white";

    const CHRONOMETER_COLOR = "rgb(255,0,75)";
    const CHRONOMETER_INTERVAL = 100 / 11;
    const CHRONOMETER_REMANINING_PROGRESS_COLOR = "rgb(30,50,61)";

    import {mapActions} from 'vuex';
    import {mapGetters} from 'vuex';

    export default {
        name: "attackometer",
        components: {
            DashboardItemMenu: DashboardItemMenu,
            LoadingModal: LoadingModal,
            Chronometer: Chronometer
        },
        props: {
            itemNumber: {
                type: Number,
                required: true
            }
        },
        mixins: [Common],
        data() {
            return {
                mainTitle: 'ATTACKOMETER',
                mainTitleColor: MENU_MAIN_TITLE_COLOR,
                mainTitleBackgroundColor: MENU_MAIN_TITLE_BACKGROUND_COLOR,
                loading: false,
                isFirstRequest: true,
                attackometerStats: [],
                selectedVendorItem: null,
                attackometerMenuList: [],
                maxFileCount: 5120,
                attackometerNumbers: [10, 20, 40, 80, 160, 320, 640, 1280, 2560, 5120],
                pageName: 'Attackometer Widget'
            }
        },
        methods: {
            setMaxFileCount() {
                var maxFileCount = this.attackometerStats[0].file_count;
                var d = Math.floor(maxFileCount / 1000);
                this.maxFileCount = (d + 1) * 1000;
            },
            setAttackometerNumbers() {
                var interval = this.maxFileCount / 10;
                var numbers = [];
                for (let i = 1; i < 11; i++) {
                    numbers.push(interval * i);
                }
                this.attackometerNumbers = numbers;
            },
            getAttackometerStats() {
                let log_start = Date.now();
                var path = Constants.INTELLIGENCE_BACKEND_URL + '/dashboard/attackometer';
                this.loading = true;
                this.$http.get(path)
                    .then(response => {
                        this.attackometerStats = response.data.data;
                        var selectedAttackometerVendor = this.getSelectedAttackometerVendor;
                        if(selectedAttackometerVendor != null && selectedAttackometerVendor.item != null){
                            this.selectedVendorItem = selectedAttackometerVendor.item;
                        }else{
                            this.selectedVendorItem = this.attackometerStats[0];
                        }
                        // this.setMaxFileCount();
                        // this.setAttackometerNumbers();
                        this.createAttackometerMenu();
                        this.$emit('loaded', 'attackometer', this.getDurationInSeconds(log_start, Date.now()));
                        this.loading = false;
                    }, response => {
                        this.loading = false;
                    });
            },
            getAttackometerItemProgress(fileCount) {
                if (fileCount > 10240)
                    return 100;
                if (fileCount <= 0)
                    return 0;
                if (fileCount <= 7)
                    return (CHRONOMETER_INTERVAL / 10) * fileCount;

                let _interval = Math.log2(fileCount / 5);
                let low_val = Math.floor(_interval);
                let high_val = low_val + 1;
                let percent = CHRONOMETER_INTERVAL * low_val;
                let current_interval = Math.pow(2, high_val) * 5 - Math.pow(2, low_val) * 5;
                let low_distance = fileCount - 5 * Math.pow(2, low_val);
                let _add_value = (low_distance / current_interval) * CHRONOMETER_INTERVAL;
                return percent + _add_value;

            },
            createAttackometerMenuItem(item) {
                item.progress = this.getAttackometerItemProgress(item.file_count);
                return {
                    id: this.uuidv4(),
                    text: item.vendor,
                    color: MENU_ITEM_COLOR,
                    progress: item.progress,
                    progressColor: CHRONOMETER_COLOR,
                    selectedColor: "white",
                    selected: this.selectedVendorItem.vendor == item.vendor,
                    item: item,
                };
            },
            createAttackometerMenu() {
                var items = [];
                for (let i = 0; i < this.attackometerStats.length; i++) {
                    let item = this.attackometerStats[i];
                    items.push(this.createAttackometerMenuItem(item));
                }
                this.attackometerMenuList = [
                    {
                        type: "selectableProgress",
                        text: "VENDORS",
                        color: MENU_TITLE_COLOR,
                        backgroundColor: MENU_ITEM_BACKGROUND_COLOR,
                        open: true,
                        items: items
                    }
                ];
            },
            onVendorSelect(menuItem) {
                let log_start = Date.now();

                this.selectedVendorItem = menuItem.item;
                // this.selectedVendorItem = null;
                this.$nextTick(function () {
                    this.$refs.mainChronometer.update();
                    this.$refs.subChronometer.update();
                });
                this.setSelectedAttackometerVendor(menuItem);
                this.saveLog(this, this.pageName, this.pageName + ' vendor clicked. Vendor name: (' + menuItem.text + ')', this.getDurationInSeconds(log_start, Date.now()), null);
            },
            onEnlargeClick() {
                let log_start = Date.now();
                let enLargeClicked = this.getDashboardEnlargedItem;
                if (enLargeClicked != null) {
                    this.saveLog(this, this.pageName, this.pageName + ' minimized.', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                else {
                    this.saveLog(this, this.pageName, this.pageName + ' maximized.', this.getDurationInSeconds(log_start, Date.now()), null);
                }
                this.setDashboardEnlargedItem(this.itemNumber);
            },

            ...mapActions([
                "setDashboardEnlargedItem",
                "setSelectedAttackometerVendor"
            ])
        },
        computed: {
            chronometerProgressColor() {
                return CHRONOMETER_COLOR;
            },
            chronometerRemainingProgressColor() {
                return CHRONOMETER_REMANINING_PROGRESS_COLOR;
            },
            oldestFileName() {
                if (this.selectedVendorItem.oldest_file == null || this.selectedVendorItem.oldest_file == undefined)
                    return '';

                var filename = this.selectedVendorItem.oldest_file.filename ? this.selectedVendorItem.oldest_file.filename : this.selectedVendorItem.oldest_file.sha1;
                if (filename.length > 25)
                    filename = filename.substr(0, 25);
                return filename;
            },
            oldestUndetectedFileText() {
                var seconds = this.getTimePassedInSeconds(this.selectedVendorItem.oldest_file.valkyrie_detect_time);

                if (seconds > (24 * 60 * 60)) {
                    var days = Math.floor(seconds / (24 * 60 * 60));
                    var remainder = seconds - (days * (24 * 60 * 60));
                    var hours = Math.floor(remainder / (60 * 60));

                    return days + " Days " + hours + " Hours";
                } else {
                    var time = this.getTimePassedInHoursAndMinutesAndSeconds(seconds);
                    return this.getTwoDigitValue(time.hours) + " : " + this.getTwoDigitValue(time.minutes) + " : " + this.getTwoDigitValue(time.seconds);
                }
            },
            ...mapGetters([
                "getSelectedAttackometerVendor",
                "getDashboardEnlargedItem"
            ])
        },
        mounted() {
        },
        beforeMount() {
            this.getAttackometerStats();
        }
    }
</script>

<style scoped>

    .main-chronometer {
        position: absolute;
        left: -17%;
        top: -10%;
        width: 100%;
        height: 100%;
    }

    .sub-chronometer {
        position: absolute;
        right: -6%;
        bottom: -28%;
        width: 50%;
        height: 100%;
    }

    .text-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .text {
        fill: white;
        font-family: Digital-Serial-Bold;
        font-size: 20px;
    }

    .small-text {
        fill: #416477;
        font-family: Digital-Serial-Bold;
        font-size: 13px;
    }

</style>



// WEBPACK FOOTER //
// src/pages/dashboard-page/attackometer/Attackometer.vue